import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type { Action, ThunkAction } from 'types';

const STATUS_LOADED = 'creatorProposalStatus/STATUS_LOADED';
const STATUS_RESET = 'creatorProposalStatus/STATUS_RESET';

const initialState = {
  statuses: {}
};

export function statusesReset(): Action {
  return {
    type: STATUS_RESET
  };
}

function statusesLoaded(statuses = {}) {
  return {
    type: STATUS_LOADED,
    payload: {
      statuses
    }
  };
}

export function fetchCreatorApprovalStatus(organizationId: number, listId: number, influencerIds: Array<number>): ThunkAction {
  return async (dispatch) => {
    try {
      const url = API.END_POINTS.CREATOR_PROPOSAL.creatorListInfluencerStatuses(organizationId, listId, influencerIds);
      const response = await get(url, {}, { suppressGlobalNotification: true });
      dispatch(statusesLoaded(response.data));
    } catch (error) {
      logError(error);
    }
  };
}

export default createReducer<any, any>('creatorProposalStatus', initialState, {
  [STATUS_RESET]: () => initialState,
  [STATUS_LOADED]: (state, { statuses }) => ({
    ...state,
    statuses: {
      ...state.statuses,
      ...statuses
    }
  })
});
